module.exports = __webpack_public_path__ + "static/media/15.166a7229.jpeg";